<template>
  <div id="inputAddress" :class="{'has-address': addressList.length > 0}">
    <!-- 검토주소 입력 -->
    <div class="input-group">
      <i class="glyphicon glyphicon-search"></i>
      <input ref="input" type="text"
             :class="[{ 'has-address': addressList.length > 0 }]"
             placeholder="검토할 주소를 입력해주세요. (최대 10개)"
             v-model="address"
             @keypress.prevent.enter="onSearch">
      <button v-show="addressList.length > 0" type="button" @click="onSearch">+</button>
    </div>
    <!-- 주소 검색결과 및 검토목록 -->
    <div class="results">
      <div class="search-list" v-if="addressResultList.length > 0 || noResult">
        <img src="http://i1.daumcdn.net/localimg/localimages/07/postcode/320/close.png" class='close' @click="close" alt="접기 버튼">
        <ul class="list-unstyled">
          <li class="item-address" v-for="item in addressResultList" @click="selectAddress(item)">
            <div>
              <label>지번</label>
              <span class="address" :data-lat="item.lat" :data-lng="item.lng">{{ item.address }}</span>
            </div>
            <div>
              <label>도로명</label><span class="new-address">{{ item.newAddress }}</span>
            </div>
          </li>
          <li v-if="noResult" class="alert alert-danger margin-0">
            검색 결과가 없습니다.<br/>
            찾으시려는 지번 또는 도로명주소+건물번호까지 상세히 입력 후 검색해 주세요.
          </li>
        </ul>
      </div>
      <div class="address-list" v-if="addressList.length > 0 && multiple">
        <ul class="list-unstyled">
          <li v-for="item in addressList">
            <span>{{ item.address }}</span>
            <span class="delete" @click="deleteAddress(item)">×</span>
          </li>
        </ul>
      </div>
    </div>
    <!-- 알림창 -->
    <modal ref="addressModal" :id="addressModal.id" :type="addressModal.type" :title="addressModal.title"
           :size="addressModal.size" :fields="addressModal.fields"></modal>
  </div>
</template>

<script>
  /**
   * 해당 컴포넌트는 비즈해줌 인덱스, 원클릭 사업검토, 프리미엄 사업검토에서 검토주소지 입력필드로 사용한다.
   * 공용 컴포넌트인 InputAddress.vue를 Minxin을 통해 재사용한다.
   * 정의된 컴포넌트에 모든 옵션을 재사용하며 커스텀 필요 시 옵션을 재정의하여 사용한다.
   */

  import InputAddress from 'common/components/InputAddress'
  import Modal from 'common/components/Modal'

  export default {
    name: 'index-input-address',
    mixins: [ InputAddress ],
    components: { Modal },
    props: {
      multiple: {
        type: Boolean,
        default: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  #inputAddress {
    width: calc(100% - 167px);
    text-align: center;
    float: left;

    &.has-address {
      @media (min-width: 768px) {
        .results {
          width: calc(100% - 58px);
        }
      }
    }

    .input-group {
      position: relative;
      width: 100%;

      input {
        width: 100%;
        height: 48px;
        padding: 16px 24px 16px 40px;
        border: 1px solid $hzc-gray-04;
        border-radius: 4px;
        float: left;

        &.has-address {
          width: calc(100% - 58px);
        }

        &:focus {
          outline: none;
          box-shadow: inset 0 0 0 2px #9b88e9;
        }
      }

      // PlaceHolder Custom
      input::placeholder,
      input:-ms-input-placeholder,
      input::-ms-input-placeholder {
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1;
        letter-spacing: normal;
        color: $hzc-gray-05;
      }

      button {
        width: 54px;
        height: 48px;
        margin-left: 4px;
        border-radius: 4px;
        box-shadow: 0 1px 1px 0 rgba(45, 55, 77, 0.3);
        border: solid 1px #e1e6f3;
        background-color: #f7f8fc;
        font-size: 24px;
        color: #39496b;

        &:focus {
          outline: none;
        }

        &:hover {
          background-color: darken(#f7f8fc, 2%);
        }
      }

      .glyphicon-search {
        position: absolute;
        top: 18px;
        left: 18px;
        font-size: 14px;
        color: $hzc-gray-07;
      }
    }

    .results {
      ul {
        margin: 0;
      }

      .search-list {
        overflow: auto;
        width: 100%;
        margin-top: 4px;
        max-height: 300px;
        position: relative;
        background: $hzc-white;
        border: 1px solid $hzc-gray-04;
        border-radius: 4px;
        text-align: left;

        li {
          padding: 16px;
        }

        .item-address:hover {
          background: #fafafa;
        }

        .new-address {
          color: #BBB;
        }

        label {
          border: 1px solid #d4e2ef;
          padding: 1px 5px;
          line-height: 1.4;
          border-radius: 3px !important;
          font-size: 12px;
          color: #008bd3;
          margin-right: 5px;
          width: 50px;
          text-align: center;
        }

        .item-address {
          cursor: pointer;
          border-bottom: 1px solid $hzc-gray-04;
          &:last-child {
            border: 0;
          }
        }

        .label {
          border: 1px solid #d4e2ef;
          padding: 1px 5px;
          line-height: 1.4;
          border-radius: 3px !important;
          font-size: 12px;
          color: #008bd3;
          margin-right: 5px;
          width: 50px;
          text-align: center;
        }

        .new-address {
          color: #BBB;
        }
      }

      .address-list {
        margin-top: 4px;
        padding: 8px;
        border-radius: 4px;
        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.13);
        background-color: #f8f9fa;
        text-align: left;

        li {
          padding: 8px;
        }

        span {
          font-size: 14px;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.14;
          letter-spacing: -0.8px;
          color: $hzc-gray-08;
        }

        .delete {
          font-weight: bold;
          font-size: 16px;
          line-height: 1;
          float: right;
          cursor: pointer;
        }
      }
    }

    @media (max-width: 767px) {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/IndexInputAddress.vue